<script>
import { sync } from 'vuex-pathify'
import { mapActions } from 'vuex'
import datePicker from '@/mixins/date-picker'
import AppService from '@/services/app.service'
import moment from 'moment'
export default {
    name: 'DebuggerFilterHeader',
    computed: {
        filter: sync('debug/filter'),
        request_id: sync('debug/request_id'),
        cardActive: sync('debug/cardActive'),
        defaultTime () {
            return [moment().format('HH:mm:ss'), moment().format('HH:mm:ss')]
        }
    },
    mixins: [datePicker],
    mounted () {
        this.filter.senderId = this.$router.currentRoute.query.sender_id
        this.initializeTimeRangeFilter()
    },
    methods: {
        ...mapActions('debug', ['fetchChatHistory']),
        submitForm () {
            this.request_id = null
            this.cardActive = null
            const [startTime, endTime] = this.filter.range ?? ''
            this.$router.push({
                name: 'Debugger',
                query: {
                    sender_id: this.filter.senderId,
                    from_time: startTime,
                    to_time: endTime
                }
            }).catch(() => {
            }).finally(async () => {
                AppService.showLoading()
                await this.fetchChatHistory(true)
                AppService.hideLoading()
            })
        },
        resetForm () {
            this.filter = {}
        },
        initializeTimeRangeFilter () {
            const startTime = this.$route.query.from_time
            const endTime = this.$route.query.to_time
            if (this.$route.query.from_time && this.$route.query.to_time) {
                this.filter.range = [startTime, endTime]
            }
        }

    }
}
</script>

<template>
  <div class="d-flex pa-3 rounded filter-container align-center">
    <el-input v-model="filter.senderId" size="small" clearable
              placeholder="Sender Id"></el-input>
    <el-date-picker :default-time="defaultTime" value-format="timestamp" size="small" type="datetimerange" format="dd/MM/yyyy HH:mm:ss" :picker-options="pickerOptions"
                    :start-placeholder="this.$f.tc('from')" style="width: 100%"
                    v-model="filter.range"
                    :end-placeholder="this.$f.tc('to')"></el-date-picker>
    <div class="flex-grow-1"></div>
    <div class="d-flex align-center justify-center">
      <el-button class="font-weight-bold" size="small" @click="resetForm">{{
          $t('clear') | capitalize
        }}
      </el-button>
      <el-button class="font-weight-bold" size="small" icon="el-icon-search" type="primary" @click="submitForm">{{
          $t('search') | capitalize
        }}
      </el-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.filter-container {
  gap: 12px;
  border-bottom: 1px solid #EDEDED;
  background: var(--ffffff, #FFF);
}
</style>
